import { IPropCreateToast } from './interfaces/prop-create-toast.interface'
import EdToastMsg from './components/ed-toast-msg/ed-toast-msg.vue';

export const ED_TOAST_EVENTS = {
  SHOW: 'SHOW',
  UPDATE: 'UPDATE',
  HIDE: 'HIDE',
}

export const EdToast = {
  install: (Vue) => {

    /* Plugin components */
    Vue.component('ed-toast-msg', EdToastMsg);

    Vue.prototype.$EdToast = new Vue({
      methods: {
        create(prop: IPropCreateToast) {
          this.$EdToast.$emit(ED_TOAST_EVENTS.SHOW, prop);
        },
        update(prop: IPropCreateToast) {
          this.$EdToast.$emit(ED_TOAST_EVENTS.UPDATE, prop);
        },
        hide() {
          this.$EdToast.$emit(ED_TOAST_EVENTS.HIDE);
        }
      }
    });

  }
}